export const errorDescribedBy = (oid) => `${oid}-validation-error`;
